
import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import 'Style/addPin.css';
import 'Style/submitButton.css';
import 'Style/backButton.css';
import 'Style/uploadButton.css'
import 'Style/feedbackButton.css'
import 'Style/textArea.css'
import AddPinForm from "./AddPinForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { setModalVisible } from 'State/addPinModalSlice';

function AddPin({ mapRef }) {

    const dispatch = useDispatch();
    const isModalVisible = useSelector((state) => state.addPinModal.isModalVisible);

    return (
        <>
        {!isModalVisible ? ( 
            <button className="addPinButton" onClick={() => dispatch(setModalVisible(true))}>
                <div className="text">Pin plaatsen</div>
                <div className="icon"><FontAwesomeIcon icon={faPlus} /></div>
            </button>
        ) : (
            <div className="addPinModal">
                <AddPinForm mapRef={mapRef} />
            </div>
        )}
        </>
    )
}

export default AddPin;
